class EditDevicePostureCheck {
    constructor() {
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');

        this.editDevicePostureCheckEvents();
    }
    editDevicePostureCheckEvents(){
        const thisClass = this;
        /** When user click on edit button redraw modal form and get device posture check values */
        $(document).on('click', '.edit-device-posture-check', function(e) {
            let devicePostureCheckID = $(this).parent()[0].id;
            thisClass.showEditDevicePostureCheckModal(devicePostureCheckID);
        });
        /** If url contains #edit-device-posture-check - show device posture check */
        if(window.location.href.includes('edit-device-posture-check') && new URLSearchParams(window.location.search).get('devicePostureCheckID')){
            thisClass.showEditDevicePostureCheckModal(new URLSearchParams(window.location.search).get('devicePostureCheckID'));
        }
    }
    /** Redraw edit device posture check form by devicePostureCheckID */
    showEditDevicePostureCheckModal(devicePostureCheckID){
        new ModalLoading();
        naja.makeRequest('GET', '/device-posture-check/?do=getDevicePostureCheckInfo', {
            'devicePostureCheckID': devicePostureCheckID,
            'organizationID': this.organizationID
        }, {
            history: false // Prevent URL changes in browser history
        }).then((response) => {
            if(response){
                let editDevicePostureCheckModal = document.getElementById('edit_device_posture_check_modal');
                /** If this is not the Default security policy - init actions and validation for edit device posture check form */
                if(!response.isDefault){
                    new DevicePostureCheckForm('edit_device_posture_check_modal', 'frm-generalForms-editDevicePostureCheckForm-editDevicePostureCheckForm', response.devicePostureCheckInfo);
                }

                KTScroll.createInstances();
                this.initDeleteDevicePostureCheck(editDevicePostureCheckModal, response.devicePostureCheckInfo);

                // Init all popovers
                const popoverTriggerList = [].slice.call(document.querySelectorAll('#edit_device_posture_check_modal [data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });

                this.hideGeneralModals(editDevicePostureCheckModal);
                new ModalLoading(editDevicePostureCheckModal);
            }
        }).catch(error => {
            new ModalLoading();
            toastr.error('Unexpected error occurred. Please try it again later or contact our support team.');
        });
    }
    initDeleteDevicePostureCheck(editDevicePostureCheckModal, devicePostureCheckInfo){
        const thisClass = this;
        const deleteDevicePostureCheckButton = editDevicePostureCheckModal.querySelector('.delete-device-posture-check');
        if(deleteDevicePostureCheckButton){
            deleteDevicePostureCheckButton.addEventListener('click', function () {
                Swal.fire({
                    html: `<span class="text-center text-primary">Device Posture Check `+(devicePostureCheckInfo.name !== undefined ? `<b>`+devicePostureCheckInfo.name+`</b> ` : ``)+`is going to be completely deleted!</span>`,
                    icon: "warning",
                    iconColor: "#FF5206",
                    buttonsStyling: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete!",
                    customClass: {
                        confirmButton: "btn btn-danger mt-0",
                        cancelButton: 'btn btn-light-primary mt-0',
                    },
                    showLoaderOnConfirm: true,
                    returnFocus: false,
                    preConfirm: () => {
                        return fetch('/device-posture-check?do=removeDevicePostureCheck&organizationID='+thisClass.organizationID+'&devicePostureCheckID='+devicePostureCheckInfo.uuid)
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error(response.statusText)
                                }
                                return response.json();
                            }).catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`)
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                    allowEscapeKey: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(result.value === 'deleted') {
                            toastr.success('Device Posture Check has been deleted.');
                            bootstrap.Modal.getOrCreateInstance(editDevicePostureCheckModal).hide();
                            new PageDatatableReload();

                            let numberOfDpcElement = $(".number-of-dpc");
                            if(numberOfDpcElement){
                                numberOfDpcElement.text(numberOfDpcElement.text() - 1);
                            }
                        } else if(result.value === 'defaultSecurityPolicy'){
                            toastr.error('Default security policy cannot be deleted.');
                        } else {
                            toastr.error('Unexpected error occurred. Please try it again later.');
                        }
                    }
                });
            });
        }
    }
    hideGeneralModals(editDevicePostureCheckModal){
        let editDeviceModal = document.getElementById('edit_device_modal');
        if(editDeviceModal && editDeviceModal.classList.contains('show')){
            bootstrap.Modal.getInstance(editDeviceModal).hide();
            new AddBackLinkToModal(editDeviceModal, editDevicePostureCheckModal);
        }
    }
}
window.EditDevicePostureCheck = EditDevicePostureCheck;